
import css from './InformationCard.module.scss';
import { strings } from 'src/localization';
import React from 'react';
import classNames from 'classnames';
import { THEME } from 'src/constants/ThemeNames';
export interface IProps {
    theme: string;
    children: React.ReactNode;
    onEdit: (e: any) => void;
    nameId: string;
    identityVerified: boolean;
    selectedVehicle: string;
}

const InformationCard = (props: IProps) => {
    const summaryCardCss = classNames(
        css.summaryCard,
        {
            [css.summaryCardBMW]: props.theme === 'bmw',
            [css.summaryCardCA]: props.theme === 'cadillac',
            [css.summaryCardLM]: props.theme === 'lexusMonogram',
            [css.summaryCardSPM]: props.theme === 'toyotaSPM',
            [css.summaryCardIN]: props.theme === 'infiniti',
            [css.summaryCardAudi]: props.theme === THEME.AUDI,
        },
    );

    const editLink = classNames(
        css.editLink,
        {
            [css.editLinkCV]: props.theme === 'chevrolet',
            [css.editLinkMB]: props.theme === 'mercedesBenz',
            [css.editLinkMazda]: props.theme === 'mazda',
            [css.editLinkGenesis]: props.theme === 'genesis',
            [css.editLinkAcura]: props.theme === 'acura',
            [css.editLinkLexus]: props.theme === 'lexus',
            [css.editLinkAudi]: props.theme === THEME.AUDI,
        },
    );

    // Handling an undefined nameID and setting to selectedVehicle in order to display Edit button for MFA.
    let apptNameId = props.nameId;
    if (apptNameId === undefined && props.selectedVehicle) {
        apptNameId = props.selectedVehicle;
    }

    const summaryTitleStyles = classNames(
        css.summaryTitle,
        {
            [css.summaryTitleHonda]: props.theme === 'honda',
            [css.summaryTitleBMW]: props.theme === 'bmw',
            [css.summaryTitleFord]: props.theme === 'ford',
            [css.summaryTitleIN]: props.theme === 'infiniti',
            [css.summaryTitleMazda]: props.theme === 'mazda',
            [css.summaryTitleGenesis]: props.theme === 'genesis',
            [css.summaryTitleAcura]: props.theme === 'acura',
            [css.summaryTitleLexus]: props.theme === 'lexus',
        },
    );

    return (
        <div className={css.flexItemLeft}>
            <div className={css.container}>
                <h4 className={summaryTitleStyles}>
                    {strings.Information}
                </h4>
                {(apptNameId && !props.identityVerified) &&
                    <span
                        id='edit'
                        className={editLink}
                        onClick={(e: any) => props.onEdit(e)}
                    >
                        {strings.Edit}
                    </span>
                }
            </div>

            <div className={summaryCardCss}>
                {props.children}
            </div>
        </div>
    );
};


export default InformationCard;